import React from 'react';
import Portfolio from '../components/Portfolio';
import LatestProjects from '../components/LatestProjects';
import Marquee from '../components/Marquee';

function PortfolioPage() {
  return (
    <>
      <Portfolio />
      <Marquee />
      <LatestProjects />     
    </>
  );
}

export default PortfolioPage;